import React from 'react';

// FAQ data
const faqs = [
  {
    question: "How long will it take to get a response?",
    answer: "Within 48 working hours.",
  },
  {
    question: "What if I'm not satisfied with the resolution?",
    answer: "You may escalate your complaint to the appropriate regulatory authority.",
  },
  {
    question: "Can I submit a complaint without an email?",
    answer: "Yes, you can also submit via phone.",
  },
  {
    question: "Will my personal information be safe?",
    answer: "Yes, your information is handled as per our privacy policy.",
  },
];

// FAQ Accordion component
function FAQAccordion() {
  const [openIndex, setOpenIndex] = React.useState(0); // First FAQ open by default

  return (
    <div className="privacy-policy-indent grievance-faq-accordion">
      {faqs.map((faq, idx) => (
        <div
          key={idx}
          className={`faq-item${openIndex === idx ? " open" : ""}`}
        >
          <button
            className="faq-question"
            onClick={() => setOpenIndex(openIndex === idx ? null : idx)}
            aria-expanded={openIndex === idx}
            aria-controls={`faq-answer-${idx}`}
          >
            <span className="faq-q">
              Q{idx + 1}. {faq.question}
            </span>
            <span className="faq-toggle-icon">
              {openIndex === idx ? "−" : "+"}
            </span>
          </button>
          {openIndex === idx && (
            <div className="faq-answer" id={`faq-answer-${idx}`}>
              {faq.answer}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default FAQAccordion;
